import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { SITE } from '@/config/site';

const menuItems = [
  { label: 'Inicio', to: '/' },
  { label: 'Inteligencia Artificial', to: '/inteligencia-artificial' },
  { label: 'Desarrollo', to: '/desarrollo-software' },
  { label: 'Integraciones', to: '/integraciones' },
  { label: 'Soluciones', to: '/soluciones' },
  { label: 'Proyectos', to: '/proyectos' },
  { label: 'Nosotros', to: '/nosotros' },
  { label: 'Contacto', to: '/contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-950/85 backdrop-blur-xl border-b border-background-800/60'
            : 'bg-transparent border-b border-transparent'
        }`}
      >
        <div className="mx-auto flex items-center justify-between gap-6 px-4 md:px-6 py-4 max-w-7xl">
          <Link to="/" className="flex items-center shrink-0 cursor-pointer">
            <img
              src={SITE.logo}
              alt="Logo de ACOMA"
              title="ACOMA — Inteligencia Artificial, Software e Integraciones"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {menuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm whitespace-nowrap rounded-md transition-colors ${
                    isActive
                      ? 'text-foreground-950'
                      : 'text-foreground-500 hover:text-foreground-900'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3 shrink-0">
            <a
              href={SITE.portalUrl || '/contacto'}
              target={SITE.portalUrl ? '_blank' : undefined}
              rel={SITE.portalUrl ? 'noopener noreferrer' : undefined}
              title="Iniciar sesión en el Portal ACOMA"
              className="inline-flex items-center gap-2 text-sm whitespace-nowrap font-medium text-foreground-900 border border-background-700 hover:border-background-600 hover:bg-background-800 rounded-md px-4 py-2.5 transition-colors cursor-pointer"
            >
              <i className="ri-login-box-line text-base"></i>
              Iniciar sesión
            </a>
            <Link
              to="/contacto"
              className="text-sm whitespace-nowrap font-medium text-background-950 bg-primary-500 hover:bg-primary-600 rounded-md px-5 py-2.5 transition-colors cursor-pointer glow-primary"
            >
              Hablemos de tu proyecto
            </Link>
          </div>

          <button
            type="button"
            aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden relative z-[60] w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-800 transition-colors cursor-pointer"
          >
            <i className={`ri-${open ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </header>

      {open && (
        <div className="lg:hidden fixed inset-0 top-[72px] bg-background-950/95 backdrop-blur-xl z-40 overflow-y-auto">
          <nav className="flex flex-col px-6 py-6 gap-1">
            {menuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 text-base rounded-lg transition-colors ${
                    isActive
                      ? 'text-foreground-950 bg-background-800'
                      : 'text-foreground-500 hover:text-foreground-900 hover:bg-background-800/60'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div className="flex flex-col gap-3 mt-6 pt-6 border-t border-background-800">
              <a
                href={SITE.portalUrl || '/contacto'}
                target={SITE.portalUrl ? '_blank' : undefined}
                rel={SITE.portalUrl ? 'noopener noreferrer' : undefined}
                onClick={() => setOpen(false)}
                className="inline-flex items-center justify-center gap-2 text-sm whitespace-nowrap font-medium text-foreground-900 border border-background-700 hover:bg-background-800 rounded-md px-5 py-3.5 transition-colors cursor-pointer"
              >
                <i className="ri-login-box-line text-base"></i>
                Iniciar sesión
              </a>
              <Link
                to="/contacto"
                onClick={() => setOpen(false)}
                className="text-sm whitespace-nowrap text-center font-medium text-background-950 bg-primary-500 hover:bg-primary-600 rounded-md px-5 py-3.5 transition-colors cursor-pointer"
              >
                Hablemos de tu proyecto
              </Link>
            </div>
          </nav>
        </div>
      )}
    </>
  );
}